import { render, staticRenderFns } from "./componentGroup.vue?vue&type=template&id=b6ca0fbc&"
import script from "./componentGroup.vue?vue&type=script&lang=js&"
export * from "./componentGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports